import React from 'react';
import AgentTrustCenterPage from '../AgentTrustCenterPageV2';

/* G301 — Deep-link wrapper into the unified Trust Center.
 *
 * The V2 Trust Center is now a SINGLE page that covers Lets and
 * ExteLets together (see AgentTrustCenterPageV2 comment block). This
 * wrapper exists purely to pre-select the "Lets" scope when an
 * operator follows a saved bookmark / nav link that historically
 * pointed at a Lets-only Trust view. From there the user can flip the
 * in-page segmented control to "All" or "ExteLets" without leaving
 * the page.
 *
 * Was a separate page in G133; now a 9-line pass-through that
 * survives to keep deep links working. Safe to remove once nav is
 * migrated to /trust?scope=native — but no rush, the cost is trivial.
 */
export default function NativeTrustCenterPage() {
  return <AgentTrustCenterPage agentScope="native" />;
}
